import AdminLayout from "@/components/admin/AdminLayout";
import { Construction } from "lucide-react";

export default function AdminStub({ title, phase = "Fase 4" }) {
    return (
        <AdminLayout title={title}>
            <div className="bg-white border border-dashed border-neutral-300 rounded-sm p-12 text-center max-w-2xl mx-auto">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-eclipse-light mb-6">
                    <Construction className="w-8 h-8 text-eclipse-cta" strokeWidth={1.5} />
                </div>
                <h2 className="font-display font-black text-2xl text-eclipse-primary mb-2">{title}</h2>
                <p className="text-eclipse-cta font-display font-bold text-sm tracking-wider uppercase mb-3">{phase}</p>
                <p className="text-eclipse-muted text-sm leading-relaxed">Esta sección se construye en la próxima fase. Mientras tanto, todas las funciones de leads, dashboard y pipeline están operativas.</p>
            </div>
        </AdminLayout>
    );
}
